import { styled, Typography } from '@mui/material'

export const SecondaryText = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
}))
